import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default class BookingDotComLinkSerializer extends ApplicationSerializer {
  attrs = {
    eligibleRatePlans: { serialize: false },
    channelConnectionId: { serialize: false },
  };
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'booking-dot-com-link': BookingDotComLinkSerializer;
  }
}
